import React, { FC } from 'react';

import { useSelector } from 'react-redux';
import { AlarmCallType } from '@x-guard/xgac-types/xgac';
import {
  statusSelector,
  errorSelector,
  isRetryingSelector,
} from 'features/details/helpers';
import { ErrorDisplay } from 'components/atoms';
import { WithAsync } from 'components/molecules';
import { useLocale } from 'lib';
import { phoneCallsSelector } from 'features/details/phoneCalls';
import { ackedSelector } from 'features/details/ack/exports';
import PhoneCall from '../dynamicConferenceCall/phoneCall';
import dccStyles from '../dynamicConferenceCall/style.module.scss';
import { HelpersList, useCallPeople } from './helpersList';
import styles from './style.module.scss';

/**
 * Helpers block.
 *
 * @version 1.0.0
 */
export const Helpers: FC = () => {

  const { t } = useLocale();

  const status = useSelector(statusSelector);
  const phoneCalls = useSelector(phoneCallsSelector);
  const helperCalls = phoneCalls.filter(({ call }) => call.type === AlarmCallType.HelperCall);
  const alarmCallOpen = phoneCalls.some(({ call }) => call.type === AlarmCallType.AlarmCall);
  const error = useSelector(errorSelector);
  const isRetrying = useSelector(isRetryingSelector);
  const people = useCallPeople(Date.now());
  const acked = useSelector(ackedSelector);

  // Only need to render if there are any helpers
  return (
    <div className={styles.helpersBlock}>
      <div className={styles.blockTitleContainer}>
        {t('Helpers_WhoHelp')}
        {status.fulfilled && (
          <span className={styles.blockCount}>{people.length}</span>
        )}
      </div>
      {/* Says nobody is connected, so also hide it while the chat already shows connected people (phone calls still loading or failed). */}
      {!acked && helperCalls.length === 0 && !people.some(({ connectedAt }) => connectedAt) && (
        <p className={styles.helperInfo}>{t('Helpers_CallInfo')}</p>
      )}
      {helperCalls.length > 0 && (
        <div className={dccStyles.dynamicConferenceCall} data-guide-target="helperCall">
          {helperCalls.map((phoneCall) => (
            <PhoneCall key={phoneCall.call._id} phoneCall={phoneCall} showParticipants={false} listenFirst={alarmCallOpen}/>
          ))}
        </div>
      )}
      <WithAsync
        status={status}
        error={() => (
          <ErrorDisplay
            isRetrying={isRetrying}
            {...error}
          />
        )}
      >
        {() => <HelpersList/>}
      </WithAsync>
    </div>
  );

};
